import Dialog from "../Controls/Dialog/Dialog";
import NP from "../NP";
import TextField from "../Controls/TextField/TextField";
import Control from "../Control";
import Label from "../Controls/Label/Label";

let S = require('string');

export default class ResetPasswordDialog extends Dialog {

	private _Email: string;
	_emailLbl: Control;
	_emailInput: TextField;
	_request: any;


	constructor(settings: object)
	{
		super(settings);
		this.EvOkButtonClick.add(this._onReset, this);
	}

	_initFields(settings: object)
	{
		this._Email = '';
		super._initFields(settings);
		this._Caption = NP.RM.getString('ResetPassword');
		this._ShowHeader = true;
	}

	_render()
	{
		super._render();

		this._emailLbl = new Label({
			ParentNode: this._contentNode,
			RK: 'ResetPwdInst'
		});

		this._emailInput = new TextField({
			ParentNode: this._contentNode,
			FullWidth: true,
			Content: S(this._Email || NP.getQueryParam("email") || "").escapeHTML().s.trim(),
			FloatingLabel: NP.RM.getString('YourEmailC'),
			InputAttributes: {name: 'email'}
		});


		this._okButton.EvClick.clear();
		this._okButton.EvClick.add(this._onReset, this);
		this._okButton.setRK('Reset');
	}

	_onReset()
	{
		if (this._emailInput.getValue())
		{
			if (!NP.isEmail(this._emailInput.getValue()))
			{
				NP.showMessage({RK: 'IncorrectEmail'});
				this._emailInput.focus();
				return false;
			}

			if (this._request)
				return false;
			this._request = NP.ajax({
				Url: NP.Config.Origin + 'auth-service',
				Type: 'POST',
				Headers: {
					'Content-Type': 'application/json;charset=utf-8'
				},
				Data: JSON.stringify({
					user: this._emailInput.getValue(),
					action: "reset"
				})
			})
				 .then((response: any) =>
				 {
					 this.hide();
					 this._request = null;
					 if (response.data)
					 {
						 NP.showMessage({RK: 'ResetPasswordMessage'});
					 }
				 })
				 .catch(() =>
				 {
					 NP.showMessage({RK: 'ResetPasswordIncorrectLoginMessage'});
					 this._request = null;
				 });
		}
		else
			this._emailInput.setFocus();
		return false;
	}
};

NP.ResetPasswordDialog = ResetPasswordDialog;